import CourseCurriculumSection from '$lib/components/Course/Sections/CourseCurriculumSection.svelte';
import CourseOverviewSection from '$lib/components/Course/Sections/CourseOverviewSection.svelte';
import CourseForWhomSection from '$lib/components/Course/Sections/CourseForWhomSection.svelte';
import CourseWhySection from '$lib/components/Course/Sections/CourseWhySection.svelte';
import CourseTakeawaysSection from '$lib/components/Course/Sections/CourseTakeawaysSection.svelte';
import CourseTeachersSection from '$lib/components/Course/Sections/CourseTeachersSection.svelte';

export const sectionComponents = [
    { id: 'Overview', component: CourseOverviewSection },
    { id: 'Who', component: CourseForWhomSection },
    { id: 'Curriculum', component: CourseCurriculumSection },
    { id: 'Takeaways', component: CourseTakeawaysSection },
    { id: 'Why', component: CourseWhySection },
    { id: 'Teachers', component: CourseTeachersSection }
] as const;